import { Component, h } from 'preact';

import Seat from '../componentsV2/Seat';

class Office extends Component {
  constructor() {
    super();

    this.focusOnEl = this.focusOnEl.bind(this);
  }
  focusOnEl() {
    const bounds = this.title.getBoundingClientRect();

    window.scrollTo(0, window.scrollY + bounds.top - 75);
  }

  render({ division_type, office, office_slug, officeholder_label, seats }) {
    return (
      <div class="office">
        <h2
          id={office_slug}
          class="office__title"
          ref={title => {
            this.title = title;
          }}
        >
          {division_type === 'statewide' && office !== 'U.S. Senate'
            ? officeholder_label
            : office}
        </h2>
        <div class="office__seats">
          {seats.map(seat => (
            <Seat key={seat.district} division_type={division_type} {...seat} />
          ))}
        </div>
      </div>
    );
  }
}

export default Office;



// WEBPACK FOOTER //
// ./components/Office.js